/* Custom hook for media queries */

import { useState, useEffect } from "react";

export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const matchQueryList = window.matchMedia(query);

    const handleChange = (e) => {
      setMatches(e.matches);
    };

    // Call handler on mount so state gets updated with initial window size
    handleChange(matchQueryList);

    matchQueryList.addEventListener("change", handleChange);

    return () => matchQueryList.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
}
